<template>
  <div>
    <table-view
      ref="tableList"
      :searchModel="searchModel"
      :tableModel="tableModel"
      :tableData="tableData"
      :pages="pages"
      :isTableLoading="isTableLoading"
      @searchChange="handleSearchChange"
      @pageChange="handlePageChange"
      @changeTitleActionBtn="handleTitleActionBtn"
      tableCardTitle="LIST"
      :right-btn-options="{ text: 'Add', isHavePermission: true }"
    >
      <template v-slot:action="{ tableRow }">
        <!-- <a
          href="javascript:void(0); "
          class="icon-trash1"
          style="color: #3a3f63"
          @click="handleRemoveItem(tableRow.row.id)"
        /> -->
        <el-popconfirm
          title="Confirm to delete？"
          confirm-button-text="confirm"
          cancel-button-text="cancel"
          @confirm="handleRemoveItem(tableRow.row.id)"
        >
          <a
            href="javascript:void(0)"
            class="icon-trash1"
            style="color: #3a3f63"
            slot="reference"
          />
        </el-popconfirm>
      </template>
      <template v-slot:parentCustomerType="{ tableRow }">
        {{ getCustomerTypeText(tableRow.row.parentCustomerType) }}
      </template>

      <template v-slot:subsidiaryCustomerType="{ tableRow }">
        {{ getCustomerTypeText(tableRow.row.childCustomerType) }}
      </template>
    </table-view>

    <!-- 新增弹窗   -->
    <el-dialog
      :visible.sync="visible"
      title="Add"
      width="446px"
      :close-on-click-modal="false"
      @close="handleClose"
    >
      <el-card shadow="never">
        <el-form ref="form" :model="form" :rules="rules" labelPosition="top">
          <el-form-item label="Parent Company" prop="parentId">
            <el-select
              v-model="form.parentId"
              style="width: 100%"
              filterable
              remote
              :remote-method="name => remoteMethod(name, true)"
              :loading="loading"
              placeholder="search"
            >
              <el-option
                v-for="item in customerList"
                :value="item.id"
                :label="item.name"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Subsidiary Company" prop="childId">
            <el-select
              v-model="form.childId"
              style="width: 100%"
              filterable
              remote
              :remote-method="name => remoteMethod(name)"
              :loading="loading2"
              placeholder="search"
            >
              <el-option
                v-for="item in childList"
                :value="item.id"
                :label="item.name"
                :key="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-card>
      <template slot="footer">
        <customize-button
          class="clear-btn"
          style="margin-right: 20px"
          @click="visible = false"
        >
          Cancel
        </customize-button>
        <customize-button type="primary" @click="handleSaveBtn">
          Save
        </customize-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { removeItem, add, getTableData } from './api'
import { getCustomer } from '../api'

export default {
  data() {
    const searchModel = [
      {
        label: 'Parent Company #',
        type: 'input',
        key: 'parentId',
      },
      {
        label: 'Parent Company Name',
        type: 'input',
        key: 'parentName',
      },
      {
        label: 'Subsidiary Company #',
        type: 'input',
        key: 'childId',
      },
      {
        label: 'Subsidiary Company Name',
        type: 'input',
        key: 'childName',
      },
    ]
    const tableModel = [
      {
        label: 'Parent Company #',
        prop: 'parentCode',
      },
      {
        label: 'Parent Company Name',
        prop: 'parentName',
      },
      {
        label: 'Subsidiary Company #',
        prop: 'childCode',
      },
      {
        label: 'Subsidiary Company Name',
        prop: 'childName',
      },
      {
        label: 'Parent Company Customer Type',
        prop: 'parentCustomerType',
        width: 240,
        slotName: 'parentCustomerType',
      },
      {
        label: 'Subsidiary Company Customer Type',
        prop: 'subsidiaryCustomerType',
        width: 248,
        slotName: 'subsidiaryCustomerType',
      },
      {
        label: 'Status',
        prop: 'status',
      },
      {
        label: 'Modified by',
        prop: 'operator',
      },
      {
        label: 'Action',
        width: 100,
        slotName: 'action',
      },
    ]
    return {
      searchModel,
      tableModel,
      tableData: [],
      pages: {},
      visible: false,
      form: {
        parentId: '',
        childId: '',
        parentCustomerType: '',
        subsidiaryCustomerType: '',
      },
      rules: {
        parentId: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        childId: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        parentCustomerType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
        subsidiaryCustomerType: [
          { required: true, message: 'Can not be empty!', trigger: 'change' },
        ],
      },
      positionList: [],
      isTableLoading: true,
      customerList: [],
      childList: [],
      loading: false,
      loading2: false,
      selectList: [
        {
          id: 1,
          name: 'Trade',
        },
        {
          id: 2,
          name: 'Eaas',
        },
        {
          id: 3,
          name: 'Saas',
        },
      ],
    }
  },
  mounted() {
    this.initTable()
  },
  methods: {
    getCustomerTypeText(type) {
      switch (type) {
        case '1':
          return 'Trade'
        case '2':
          return 'Eaas'
        case '3':
          return 'Saas'
        default:
          return ''
      }
    },
    customerType(val) {
      if (val === 1) {
        return 'Trade'
      } else if (val === 2) {
        return 'Eaas'
      } else if (val === 3) {
        return 'Saas'
      }
    },
    async remoteMethod(name, flag) {
      if (name !== '') {
        this.loading = true
        const data = await this._getCustomer(name)
        if (flag) {
          this.customerList = data.map(item => ({
            ...item,
            name: `${item.name} - ${this.customerType(item.customerType)}`,
          }))
          this.loading = false
        } else {
          this.childList = data.map(item => ({
            ...item,
            name: `${item.name} - ${this.customerType(item.customerType)}`,
          }))
          this.loading2 = false
        }
      } else {
        flag ? (this.customerList = []) : (this.childList = [])
      }
    },
    initTable() {
      const params = this.$refs.tableList.getSearchData()
      this._getTableData(params)
    },
    async _getTableData(params) {
      this.isTableLoading = true
      try {
        const { data, page } = await getTableData(params)
        this.tableData = data
        this.pages = page
      } catch (err) {
        console.error(err)
      }
      this.isTableLoading = false
    },
    handleSearchChange(params) {
      params.current = 1
      this._getTableData(params)
    },
    handlePageChange(params) {
      this._getTableData(params)
    },
    async handleRemoveItem(id) {
      try {
        this.isTableLoading = true
        await removeItem(id)
        this.$message.success('success')
        this.initTable()
      } catch (err) {
        console.error(err)
        this.isTableLoading = false
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async handleSaveBtn() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        try {
          await add({ ...this.form })
          this.$message.success('success')
          this.initTable()
          this.visible = false
        } catch (err) {
          console.error(err)
        }
      }
    },
    async updateAndAdd(params) {
      try {
        await add(params)
        this.$message.success('success')
        this.initTable()
        this.visible = false
      } catch (err) {
        console.error(err)
      }
    },
    async handleTitleActionBtn() {
      this.visible = true
    },
    async _getCustomer(name) {
      try {
        return await getCustomer(name)
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
